type SocialPlatform = 'tiktok' | 'instagram' | 'youtube';

const platformUrls: Record<SocialPlatform, (handle: string) => string> = {
  tiktok: (handle) => `https://www.tiktok.com/@${handle}`,
  instagram: (handle) => `https://www.instagram.com/${handle}`,
  youtube: (handle) => `https://www.youtube.com/@${handle}`,
};

const looksLikeUrl = (value: string) =>
  /^https?:\/\//i.test(value) || value.startsWith('www.');

const ensureProtocol = (value: string) => (looksLikeUrl(value) ? value : `https://${value}`);

export const normalizeSocial = (platform: SocialPlatform, input: string) => {
  const normalizedInput = input.trim();
  if (!normalizedInput) {
    return { handle: null, url: null, normalizedInput: '' };
  }

  const isHandleInput = normalizedInput.startsWith('@') || !looksLikeUrl(normalizedInput);
  if (isHandleInput) {
    const handle = normalizedInput.replace(/^@/, '').trim();
    if (!handle) {
      return { handle: null, url: null, normalizedInput };
    }
    return {
      handle,
      url: platformUrls[platform](handle),
      normalizedInput,
    };
  }

  const url = ensureProtocol(normalizedInput);
  let handle: string | null = null;

  try {
    const parsed = new URL(url);
    const pathname = parsed.pathname || '';

    if (platform === 'tiktok') {
      const match = pathname.match(/@([^/?#]+)/);
      handle = match?.[1] || null;
    } else if (platform === 'instagram') {
      const parts = pathname.split('/').filter(Boolean);
      handle = parts[0] || null;
    } else if (platform === 'youtube') {
      const match = pathname.match(/@([^/?#]+)/);
      handle = match?.[1] || null;
    }
  } catch (error) {
    handle = null;
  }

  return { handle, url, normalizedInput };
};
